import emissionsPerCapita from "../../data/emissions_per_capita.json";
import Accordion from "../common/Accordion";
import Select from "../common/Select";

const FootprintPerCapitaSelect = () => {
  const list = [
    {
      id: 1,
      title: (
        <h4 className="text-heading text-left font-header text-xl font-semibold sm:text-center">
          Need help in deciding how much carbon dioxide to remove?{" "}
        </h4>
      ),
      content: <Select list={emissionsPerCapita}></Select>,
    },
  ];
  return (
    <>
      <div className="m-auto flex max-w-7xl flex-col items-center">
        <Accordion list={list}></Accordion>
      </div>
    </>
  );
};

export default FootprintPerCapitaSelect;
